<template>
  <ThePage :title="i18n(translations.pageTitle)">
    <template #pageTitle>
      {{ i18n(translations.title, { merchantName: companyName }) }}
    </template>

    <template #pageContent>
      <div class="space-y-24">
        <div class="md:grid md:grid-cols-3 md:gap-24">
          <TaskList class="mb-24 w-full md:mb-0" />

          <div class="col-span-2 space-y-24">
            <SaleInsights />
            <Opportunities />
          </div>
        </div>

        <div class="md:grid md:grid-cols-2 md:gap-24">
          <CustomerReviews class="mb-24 md:mb-0" />
          <Feedbacks />
        </div>

        <div
          :class="isBuybackEnabled ? 'md:grid md:grid-cols-2 md:gap-24' : ''"
        >
          <TradeIn v-if="isBuybackEnabled" />
          <Wallet />
        </div>
      </div>

      <SignTermsAndConditionsModal />
      <TheFooter />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './Home.translations'
import CustomerReviews from './components/CustomerReviews/CustomerReviews.vue'
import Feedbacks from './components/Feedbacks/Feedbacks.vue'
import Opportunities from './components/Opportunities/Opportunities.vue'
import SaleInsights from './components/SaleInsights/SaleInsights.vue'
import SignTermsAndConditionsModal from './components/SignTermsAndConditionsModal/SignTermsAndConditionsModal.vue'
import TaskList from './components/TaskList/TaskList.vue'
import TradeIn from './components/TradeIn/TradeIn.vue'
import Wallet from './components/Wallet/Wallet.vue'

const { companyName, isBuybackEnabled } = useSellerInfoStore()

const i18n = useI18n()
</script>
